import { cn } from "helpers/classNames";
import React, { ElementType } from "react";

interface Props<T extends ElementType = "label"> {
  children: React.ReactNode;
  light?: boolean;
  required?: boolean;
  as?: T;
}

type ModalLabelProps<T extends ElementType> = Props<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof Props<T>>;

export const ModalLabel = <T extends ElementType = "label">({
  children,
  light = false,
  className,
  required = false,
  as,
  ...rest
}: ModalLabelProps<T>) => {
  const Component = as || "label";

  return (
    <Component
      className={cn(
        "flex text-sm font-medium",
        light ? "text-gray-600" : "text-gray-950",
        className,
      )}
      {...rest}
    >
      {children}
      {required && <span className="ml-0.5">*</span>}
    </Component>
  );
};
